import { useEffect, useState } from 'react';
import { base_url } from '../../Api/apiConfig';
import { buildLimits } from './listingLimits';

const CACHE_KEY = 'listing_rules_cache';

const readCache = () => {
  try {
    const raw = JSON.parse(localStorage.getItem(CACHE_KEY));
    return raw && typeof raw === 'object' ? raw : null;
  } catch (e) {
    return null;
  }
};

// Loads the admin-managed listing rules. Always re-fetches on mount so admin changes apply
// immediately; the last successful copy is kept only as a fallback if the request fails.
// Returns { L, loading, error }: L is null until rules are available.
export default function useListingLimits() {
  const [values, setValues] = useState(readCache);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let alive = true;
    fetch(`${base_url}/listing-rules`, {
      headers: { Accept: 'application/json', Authorization: `Bearer ${localStorage.getItem('login')}` },
    })
      .then((res) => (res.ok ? res.json() : Promise.reject(new Error('bad status'))))
      .then((json) => {
        const fresh = json?.data?.values;
        if (!fresh || typeof fresh !== 'object') throw new Error('bad payload');
        try { localStorage.setItem(CACHE_KEY, JSON.stringify(fresh)); } catch (e) { /* storage unavailable */ }
        if (alive) { setValues(fresh); setFailed(false); }
      })
      .catch(() => { if (alive) setFailed(true); });
    return () => { alive = false; };
  }, []);

  return {
    L: values ? buildLimits(values) : null,
    loading: !values && !failed,
    error: !values && failed,
  };
}
